import React, { FC, ReactNode } from 'react';

export type RSBorderedListItemProps = {
  leftContent: ReactNode;
  rightContent?: ReactNode;
  additionalContent?: ReactNode;
};

export const RSBorderedListItem: FC<RSBorderedListItemProps> = ({
  leftContent,
  rightContent,
  additionalContent,
}) => {
  return (
    <li className="list-style-none first-of-type:rounded-t-10 last-of-type:rounded-b-10 group box-border block border-b border-l-0 border-r-0 border-t-0 border-solid border-gray-200 last-of-type:border-b-0">
      <div className="group-first-of-type:rounded-t-10 group-last-of-type:rounded-b-10 box-border bg-white p-2.5">
        <div className="flex items-center justify-between">
          <div>{leftContent}</div>
          {rightContent && <div>{rightContent}</div>}
        </div>
        {additionalContent && <div className="mt-1">{additionalContent}</div>}
      </div>
    </li>
  );
};
